<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.femaleManager.maleManager.$invalid 
      || $v.femaleManager.femaleManager.$invalid
      || $v.femaleManager.resultMemo.$invalid 
      || $v.femaleManager.actionMemo.$invalid">
      <div v-if="$v.femaleManager.maleManager.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">管理職数（男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femaleManager.maleManager.$invalid && !$v.femaleManager.maleManager.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femaleManager.maleManager.$invalid && $v.femaleManager.maleManager.numeric && !$v.femaleManager.maleManager.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.femaleManager.femaleManager.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">管理職数（女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femaleManager.femaleManager.$invalid && !$v.femaleManager.femaleManager.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.femaleManager.femaleManager.$invalid && $v.femaleManager.femaleManager.numeric && !$v.femaleManager.femaleManager.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.femaleManager.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.femaleManager.resultMemo.$invalid && !$v.femaleManager.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.femaleManager.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.femaleManager.actionMemo.$invalid && !$v.femaleManager.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">管理職数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femaleManager.$model.maleManager" type="text" name="femaleManager.maleManager" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.femaleManager.$model.femaleManager" type="text" name="femaleManager.femaleManager" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfManager" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            女性管理職比率
            <strong><Currency :value="this.calFemaleManagerRatio"/></strong>%
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="femaleManager.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(femaleManager.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="femaleManager.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    femaleManager: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    sumOfManager() {
      if ( !(this.femaleManager.maleManager!=null && this.femaleManager.femaleManager!=null) ) {
        return null;
      }else if ( String(this.femaleManager.maleManager).length * String(this.femaleManager.femaleManager).length ==  0 ) {
        return null;
      }else if ( isNaN(this.femaleManager.maleManager) || isNaN(this.femaleManager.femaleManager)) {
        return null;
      }else{
        return Number(this.femaleManager.maleManager) + Number(this.femaleManager.femaleManager);
      }
    },
    calFemaleManagerRatio() {
      if ( this.sumOfManager != null && this.femaleManager.femaleManager != null ){
        if(this.sumOfManager == 0) return null;
        if(this.femaleManager.femaleManager == 0) return 0;
        let val = (this.femaleManager.femaleManager / this.sumOfManager) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }
  },
  validations: {
    femaleManager: {
      maleManager : { numeric, between: between(0,99999) },         // 管理職数（男性）
      femaleManager : { numeric, between: between(0,99999) },       // 管理職数（女性）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    femaleManager() {
      this.inputFemaleManager();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputFemaleManager() {
      this.$emit("change-female-manager", {
        femaleManager: this.femaleManager,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
